import React from 'react';

export const ValueDisplay = ({ option }) => {
  const newContact = !option.name;

  if (newContact) {
    return <div className="ValueDisplay">{option.value}</div>;
  }

  const keys = {
    mailgun: 'email',
    twilio: 'tel',
  };

  const key = keys[option.type];

  return (
    <div className="ValueDisplay">
      <span>
        {option.name}({option[key]})
      </span>
    </div>
  );
};
